import React from 'react';

type Props = {
  text: string;
};

const SectionTitle = ({ text }: Props) => {
  return (
    <h3 className="text-[#111928] dark:text-dark-text-primary text-2xl font-bold leading-none max-w-full break-words whitespace-pre-wrap">
      {text}
    </h3>
  );
};

export default SectionTitle;
